import { render, staticRenderFns } from "./exp-2.vue?vue&type=template&id=222a6ffb&"
import script from "./exp-2.vue?vue&type=script&lang=js&"
export * from "./exp-2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports